"use strict";
// @generated by protoc-gen-es v1.10.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/event/v1/admin_common.proto (package spwn.event.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
Object.defineProperty(exports, "__esModule", { value: true });
exports.TicketBonusMedia = exports.EventBonusMedia = void 0;
const protobuf_1 = require("@bufbuild/protobuf");
/**
 * @generated from message spwn.event.v1.EventBonusMedia
 */
class EventBonusMedia extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * アップロードされたファイルのID
         *
         * @generated from field: string media_id = 1;
         */
        this.mediaId = "";
        /**
         * アップロードされたファイルの名前
         *
         * @generated from field: string filename = 2;
         */
        this.filename = "";
        /**
         * 特典名
         *
         * @generated from field: string bonus_name = 3;
         */
        this.bonusName = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EventBonusMedia().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EventBonusMedia().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EventBonusMedia().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EventBonusMedia, a, b);
    }
}
exports.EventBonusMedia = EventBonusMedia;
EventBonusMedia.runtime = protobuf_1.proto3;
EventBonusMedia.typeName = "spwn.event.v1.EventBonusMedia";
EventBonusMedia.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "media_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "filename", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "bonus_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.event.v1.TicketBonusMedia
 */
class TicketBonusMedia extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new TicketBonusMedia().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new TicketBonusMedia().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new TicketBonusMedia().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(TicketBonusMedia, a, b);
    }
}
exports.TicketBonusMedia = TicketBonusMedia;
TicketBonusMedia.runtime = protobuf_1.proto3;
TicketBonusMedia.typeName = "spwn.event.v1.TicketBonusMedia";
TicketBonusMedia.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "media_info", kind: "message", T: EventBonusMedia },
    { no: 2, name: "release_at", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 3, name: "expired_at", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
]);
//# sourceMappingURL=admin_common_pb.js.map